import { Text } from "@clipboard-health/ui-react";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import InfoIcon from "@mui/icons-material/Info";
import WarningIcon from "@mui/icons-material/Warning";
import { Alert, Box, Stack } from "@mui/material";
// eslint-disable-next-line no-restricted-imports
import Markdown from "markdown-to-jsx";

import { useOutageBanner } from "./useOutageBanner";

export function OutageBanner() {
  const outageAlert = useOutageBanner();

  if (!outageAlert.isVisible) {
    return null;
  }

  const { severity, title, body } = outageAlert.data;

  const getIcon = (severity: string) => {
    switch (severity) {
      case "warning": {
        return <WarningIcon sx={{ margin: "8px" }} />;
      }

      case "error": {
        return <ErrorIcon sx={{ margin: "8px" }} />;
      }

      case "info": {
        return <InfoIcon sx={{ margin: "8px" }} />;
      }

      case "success": {
        return <CheckCircleIcon sx={{ margin: "8px" }} />;
      }

      default: {
        return <WarningIcon sx={{ margin: "8px" }} />;
      }
    }
  };

  return (
    <Alert
      icon={getIcon(severity)}
      severity={severity}
      sx={{
        borderRadius: 2,
        p: 2,
        minWidth: 300,
      }}
    >
      <Stack direction="row" alignItems="center" spacing={2}>
        <Box>
          <Text variant="h2" color={severity}>
            {title}
          </Text>
          <Markdown>{body}</Markdown>
        </Box>
      </Stack>
    </Alert>
  );
}
